export default __webpack_public_path__ + "static/media/paula.4f8f8310.png";